import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Results.MddCurveFittingAlgorithm`]: 'Curve Fitting',
      [`cwdChart.XAxisMin`]: 'Water Content Start',
      [`cwdChart.XAxisMajorStep`]: 'Water Content Division Size',
      [`cwdChart.YAxisToXAxisStepRatio`]: 'Converted Wet Density to Water Content Ratio',

      [`mddChart.XAxisMin`]: 'Water Content Start',
      [`mddChart.XAxisMajorStep`]: 'Water Content Division Size',
      [`mddChart.YAxisToXAxisStepRatio`]: 'Dry Unit Weight to Water Content Ratio',
    }),
    convertLabelUomMapToConfig({
      [`cwdChart.XAxisMin`]: '%',
      [`cwdChart.XAxisMajorStep`]: '%',

      [`mddChart.XAxisMin`]: '%',
      [`mddChart.XAxisMajorStep`]: '%',
    })
  );

export default getLabelConfig;
